export const BTN_ACTION = {
  style: 'height: 50px; width: 300px; border-radius: 10px;',
};

export const BTN_UPLOAD = {
  style: 'height: 50px; width: 200px; border-radius: 10px;',
  autoWidthStyle: 'height: 50px; width: auto; border-radius: 10px;',
};

export const BTN_EXPORT = {
  style: 'height: 50px; width: 160px; border-radius: 10px;',
};